import { toast } from "sonner";
import { UserPlus, Check, Clock, UserMinus, Ban, UserCheck } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../ui/button";

// Shared friend action button driven by relation status.
export default function FriendButton({ userId, status, onChanged, size = "default" }) {
  const act = async (path, label) => {
    try {
      await api.post(`/social/${path}/${userId}`);
      onChanged && onChanged();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };
  const cls = size === "sm" ? "h-8 px-3 text-xs" : "h-9 px-4 text-sm";

  if (status === "blocked") {
    return <Button data-testid={`unblock-${userId}`} onClick={() => act("unblock", "")} variant="outline" className={`rounded-full font-bold ${cls}`}><Ban className="h-4 w-4 mr-1.5" /> Unblock</Button>;
  }
  if (status === "blocked_by") {
    return <Button disabled variant="outline" className={`rounded-full font-bold ${cls} opacity-60`}>Unavailable</Button>;
  }
  if (status === "friends") {
    return <Button data-testid={`unfriend-${userId}`} onClick={() => act("friends/remove", "")} variant="outline" className={`rounded-full font-bold ${cls}`}><UserCheck className="h-4 w-4 mr-1.5 text-emerald-500" /> Friends</Button>;
  }
  if (status === "pending_out") {
    return <Button data-testid={`cancel-req-${userId}`} onClick={() => act("friends/remove", "")} variant="outline" className={`rounded-full font-bold ${cls}`}><Clock className="h-4 w-4 mr-1.5" /> Requested</Button>;
  }
  if (status === "pending_in") {
    return (
      <div className="flex gap-2">
        <Button data-testid={`accept-req-${userId}`} onClick={() => act("friends/accept", "")} className={`rounded-full font-bold text-white bg-[#2AB7CA] hover:bg-[#1f9fb0] ${cls}`}><Check className="h-4 w-4 mr-1.5" /> Accept</Button>
        <Button data-testid={`decline-req-${userId}`} onClick={() => act("friends/remove", "")} variant="outline" className={`rounded-full font-bold ${cls}`}>Decline</Button>
      </div>
    );
  }
  return <Button data-testid={`add-friend-${userId}`} onClick={() => act("friends/request", "")} className={`rounded-full font-bold text-white bg-[#FF5A79] hover:bg-[#e04865] ${cls}`}><UserPlus className="h-4 w-4 mr-1.5" /> Add friend</Button>;
}

export { FriendButton };
